import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmptyState = ({ onResetFilters }) => {
  return (
    <div className="flex flex-col items-center justify-center py-12 md:py-16 px-4">
      <div className="w-20 h-20 md:w-24 md:h-24 bg-muted rounded-full flex items-center justify-center mb-6">
        <Icon name="SearchX" size={40} color="var(--color-muted-foreground)" />
      </div>
      <h3 className="text-xl md:text-2xl font-heading font-semibold mb-2 text-center">
        No Matches Found
      </h3>
      <p className="text-sm md:text-base text-muted-foreground text-center max-w-md mb-6">
        We couldn't find any profiles matching your current filters. Try adjusting your search criteria to discover more potential matches.
      </p>
      <div className="flex flex-col sm:flex-row gap-3">
        <Button
          variant="outline"
          iconName="RotateCcw"
          iconPosition="left"
          onClick={onResetFilters}
        >
          Reset All Filters
        </Button>
        <Button
          variant="default"
          iconName="Search"
          iconPosition="left"
          onClick={() => window.location.href = '/member-dashboard'}
        >
          Back to Dashboard
        </Button>
      </div>
    </div>
  );
};

export default EmptyState;